(function () {
  const SLIDER_SELECTORS = [
    '.c-latest-arrival__slider',
    '.c-collections-items__slider',
    '.c-collections__slider',
    '.c-collections__tabs',
    '.c-latest-arrival__tabs',
    '.c-high-end-reel__tabs'
  ];
  const COMBINED_SELECTOR = SLIDER_SELECTORS.join(',');
  const DRAG_THRESHOLD = 5;

  function initDragScroll(slider) {
    if (slider.dataset.dragInit === '1') return;
    slider.dataset.dragInit = '1';

    slider.style.cursor = 'grab';

    let isDown = false;
    let startX = 0;
    let scrollStart = 0;
    let hasDragged = false;
    let prevSnap = '';
    let prevBehavior = '';

    function onMouseDown(e) {
      if (e.button !== 0) return;
      if (slider.scrollWidth <= slider.clientWidth) return;

      isDown = true;
      hasDragged = false;
      startX = e.pageX;
      scrollStart = slider.scrollLeft;

      prevSnap = slider.style.scrollSnapType;
      prevBehavior = slider.style.scrollBehavior;
      slider.style.scrollSnapType = 'none';
      slider.style.scrollBehavior = 'auto';
      slider.style.cursor = 'grabbing';
      slider.style.userSelect = 'none';

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);

      e.preventDefault();
    }

    function onMouseMove(e) {
      if (!isDown) return;
      const dx = e.pageX - startX;
      if (Math.abs(dx) > DRAG_THRESHOLD) hasDragged = true;
      slider.scrollLeft = scrollStart - dx;
    }

    function onMouseUp() {
      if (!isDown) return;
      isDown = false;

      slider.style.scrollSnapType = prevSnap;
      slider.style.scrollBehavior = prevBehavior;
      slider.style.cursor = 'grab';
      slider.style.userSelect = '';

      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);

      if (hasDragged) {
        const suppress = function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
        };
        slider.addEventListener('click', suppress, { capture: true, once: true });
      }
    }

    slider.addEventListener('mousedown', onMouseDown);
    slider.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function scanAndInit(root) {
    (root || document).querySelectorAll(COMBINED_SELECTOR).forEach(initDragScroll);
  }

  function onReady() {
    scanAndInit();
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(COMBINED_SELECTOR)) initDragScroll(node);
          if (node.querySelectorAll) scanAndInit(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
